const VARIABLE_REFERENCE_URL = process.env.API_URL + '/xugarhero/variable-reference';

const getVariableReferences = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(VARIABLE_REFERENCE_URL).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

export default {
  getVariableReferences
};



// WEBPACK FOOTER //
// ./src/brand/health/api/variableReference/index.js